import { Box, ButtonBase, Typography } from '@mui/material';

// Menu de abas do projeto, em dois grupos (v1.18.0). Cada item aponta para o mesmo número de
// aba que o ProjetoDetalhe já usa nos <TabPanel index={...}>, então o conteúdo das abas não muda.
//
//   grupos = [{ titulo, cor, itens: [{ indice, label, icone, breve }] }]
//   valor = número da aba aberta | onChange(novoNumero)
export default function AbasProjeto({ grupos, valor, onChange }) {
  return (
    <Box
      sx={{
        backgroundColor: 'white', border: '1px solid #e6e9ef', borderRadius: 3,
        px: { xs: 1.5, sm: 2.5 }, py: 0.5,
      }}
    >
      {grupos.map((g, i) => (
        <Box
          key={g.titulo}
          sx={{
            display: 'grid', gridTemplateColumns: { xs: '1fr', md: '150px 1fr' },
            alignItems: 'center', columnGap: 2, rowGap: 0.5, py: 1.25,
            borderTop: i === 0 ? 'none' : '1px solid #eef0f3',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 4, height: 16, borderRadius: 2, backgroundColor: g.cor }} />
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#475569' }}>{g.titulo}</Typography>
          </Box>

          <Box role="tablist" aria-label={g.titulo} sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
            {g.itens.map((it) => {
              const ativa = valor === it.indice;
              return (
                <ButtonBase
                  key={it.indice} role="tab" aria-selected={ativa}
                  onClick={() => onChange(it.indice)}
                  sx={{
                    height: 36, px: 1.5, gap: 0.9, borderRadius: 2,
                    fontFamily: 'inherit', fontSize: 13.5, fontWeight: 600,
                    color: ativa ? 'white' : '#475569',
                    backgroundColor: ativa ? g.cor : 'transparent',
                    transition: 'background-color 0.15s, color 0.15s',
                    '&:hover': { backgroundColor: ativa ? g.cor : '#f1f5f9' },
                    '&.Mui-focusVisible': { outline: '2px solid #2563EB', outlineOffset: 2 },
                  }}
                >
                  <Box component="span" sx={{ display: 'inline-flex', '& svg': { fontSize: 18 } }}>{it.icone}</Box>
                  {it.label}
                  {it.breve && (
                    <Box
                      component="span"
                      sx={{
                        fontSize: 10, fontWeight: 700, px: 0.7, py: 0.1, borderRadius: 1,
                        color: ativa ? 'white' : '#94a3b8',
                        backgroundColor: ativa ? 'rgba(255,255,255,0.22)' : '#eef0f3',
                      }}
                    >
                      em breve
                    </Box>
                  )}
                </ButtonBase>
              );
            })}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
